//  ! 🔥 💪🏻 Bn Ramadan fullstack MERN project 2 ( E-commerce fullstack app )
//  ! " The end of this project is the completing of future successes and creativity , Just strive, be patient, commit and keep going. "
//  ! 🔥 💪🏻 Always forward ! 💪🏻 🔥
import p1_img from './product_1.png';
import p2_img from './product_2.png';
import p3_img from './product_3.png';
import p4_img from './product_4.png';

let data_product = [
  {
    id: 1,
    name: "It is just an example of women's products",
    image: p1_img,
    new_price: 50.0,
    old_price: 80.5,
  },
  { id: 2, name: "It is just an example of women's products", image: p2_img, new_price: 85.0, old_price: 120.5 },
  { id: 3, name: "It is just an example of women's products", image: p3_img, new_price: 60.0, old_price: 100.5 },
  { id: 4, name: "It is just an example of women's products", image: p4_img, new_price: 100.0, old_price: 150.0 },
];

export default data_product;
